<template>
  <div class="app-container">
    <el-upload
      class="avatar-uploader"
      type="drag"
      ref="uploadLogoRef"
      :action="imageUpAddr"
      :headers="{ Authorization: token }"
      :show-upload-list="false"
      :format="['jpg', 'jpeg', 'png', 'webp']"
      :before-upload="handleBrforUploadLogo"
      list-type="picture-card"
      :on-progress="handleUploadLogoProgress"
      :on-success="handleUploadLogoSuccess"
    >
      <div>
        <template v-if="uploading">
          <!-- 正在上传图片 -->
          <div :style="{ height: height, 'line-height': height }">
            <el-progress :percentage="uploadProgess"></el-progress>
          </div>
        </template>
        <template v-else>
          <template v-if="isNull(imageAddr)">
            <div
              :style="{
                width: width,
                height: height,
                'line-height': '120px',
                'text-align': 'center',
                margin: '0 auto',
              }"
            >
              <svg-icon class="iconClass" iconClass="ios-camera"></svg-icon>
            </div>
          </template>
          <template v-else class="showDelete">
            <el-image
              :src="getCosFileUrl(imageAddr)"
              :width="width"
              :height="height"
            ></el-image>
            <div class="mask">
              <span @click.stop="handleRemove()">
                <svg-icon iconClass="delete2" class="deleteClass"></svg-icon>
              </span>
            </div>
            <!-- <span
              class="el-upload-list__item-delete"
              @click.stop="handleRemove()"
            >
              <svg-icon iconClass="delete2"></svg-icon>
            </span> -->
          </template>
        </template>
      </div>
    </el-upload>
  </div>
</template>

<script setup>
import { isNull } from "@/utils/fangerUtils";
import { ref } from "vue";
import useAccountStore from "@/store/modules/account";
import { deleteFile } from "@/api/warehouse/product";
import { errorMsg } from "@/utils/msgBox";
import { getCosFileUrl } from "@/utils/fangerUtils";
const accountStore = useAccountStore();
const token = accountStore.token;
const props = defineProps({
  imageAddr: {
    // 显示的图片地址
    require: false,
    type: String,
    default: "",
  },
  width: {
    // 图片的宽高
    require: false,
    type: String,
    default: "100px",
  },
  height: {
    // 图片的宽高
    require: false,
    type: String,
    default: "100px",
  },
});

const emits = defineEmits(["onSuccess"]);
const uploading = ref(false);
// 上传logo
const imageUpAddr = process.env.VUE_APP_BASE_API + "/cos/uploadProductImage";
const uploadLogoRef = ref(null);
const uploadProgess = ref(0);
// 上传成功回调
const handleUploadLogoSuccess = (response, file, fileList) => {
  uploadLogoRef.value.clearFiles();
  uploading.value = false;
  emits("onSuccess", response.data);
};

// 上传前操作
const handleBrforUploadLogo = () => {
  uploading.value = true;
};

// 上传时
const handleUploadLogoProgress = (e, file, fileList) => {
  uploadProgess.value = fileList[0].percentage;
};

const handleRemove = (uploadFile, uploadFiles) => {
  deleteFile({ url: props.imageAddr })
    .then((res) => {
      uploadLogoRef.value.clearFiles();
      emits("onSuccess", "");
    })
    .catch((err) => {
      errorMsg("删除失败");
    });
};
</script>

<style lang="scss" scoped>
// .avatar-uploader :deep(.el-upload) {
//   border: 1px dashed var(--el-border-color);
//   border-radius: 6px;
//   cursor: pointer;
//   position: relative;
//   overflow: hidden;
//   transition: var(--el-transition-duration-fast);
// }

// .avatar-uploader :deep(.el-upload:hover) {
//   border-color: var(--el-color-primary);
// }

.iconClass {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  text-align: center;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(100, 100, 100, 0.5);
  color: #ffffff;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 1;
  }

  .deleteClass {
    width: 20px;
    height: 20px;
    &:hover {
      color: #70aeed;
    }
  }
}
</style>
